<template>
  <v-card class="mt-4 mx-auto">
    <v-sheet class="v-sheet--offset mx-auto" elevation="12" max-width="90%">
      <line-chart :data="dataCollection" :options="options"></line-chart>
    </v-sheet>
    <v-card-text v-if="percentDif > 0 && chartValues.length > 0" class="pt-0">
      <div class="title font-weight-light mb-2">GDR</div>
      <v-icon class="mdi mdi-arrow-down theme--light red--text mb-1" size="15"></v-icon>
      <span class="red--text text--lighten 5">{{ percentDif }}%</span>
      <span class="subheading font-weight-light grey--text ml-1">Decrease in GDR</span>
    </v-card-text>
    <v-card-text v-if="percentDif < 0 && chartValues.length > 0" class="pt-0">
      <div class="title font-weight-light mb-2">GDR</div>
      <v-icon class="mdi mdi-arrow-up theme--light green--text mb-1" size="15"></v-icon>
      <span class="green--text text--lighten 5">{{ Math.abs(percentDif) }}%</span>
      <span class="subheading font-weight-light grey--text ml-1">Increase in GDR</span>
    </v-card-text>
    <v-card-text v-if="percentDif === 0 && chartValues.length > 0" class="pt-0">
      <div class="title font-weight-light mb-2">GDR</div>
      <v-icon class="mdi mdi-arrow-up theme--light green--text mb-1" size="15"></v-icon>
      <span class="subheading font-weight-light grey--text ml-1">No change in GDR</span>
    </v-card-text>
    <v-card-text v-if="chartValues.length < 1" class="pt-0">
      <div class="title font-weight-light mb-2">GDR</div>
      <v-divider class="my-2"></v-divider>
      <v-alert type="info">No Data for selected input</v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from 'axios';
import LineChart from '../charts/LineChart';

export default {
  components: {
    LineChart,
  },
  props: [
    'visible',
    'kpiData',
  ],
  data() {
    return {
      dataCollection: null,
      chartMonths: [],
      chartValues: [],
      percentDif: 0,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: true,
          mode: 'single',
          callbacks: {
            label(tooltipItems, data) {
              return `GDR: ${tooltipItems.yLabel}%`;
            },
          },
        },
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Months',
              },
              gridLines: {
                color: 'rgba(0, 0, 0, 0)',
              },
            },
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'GDR',
              },
              gridLines: {
                color: 'rgba(0, 0, 0, 0)',
              },
            },
          ],
        },
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      if (this.visible === true) {
        this.chartMonths = [];
        this.chartValues = [];

        this.kpiData.forEach((info) => {
          info.gdr = (info['generic rx count'] / info['all rx count']).toFixed(2) * 100;

          this.chartMonths.push(info._id.month);
          this.chartValues.push(info.gdr);
        });
        this.getPercentDif();
      }
    },
    chartData() {
      const chartColor = this.randomColor();

      this.dataCollection = {
        labels: this.chartMonths,
        datasets: [
          {
            label: 'GDR',
            fill: false,
            borderColor: chartColor,
            pointBackgroundColor: chartColor,
            pointRadius: 4,
            data: this.chartValues,
          },
        ],
      };
    },
    randomColor() {
      const letters = '0123456789ABCDEF'.split('');
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    async getPercentDif() {
      // check for undefined values
      const firstVal = this.chartValues[0] ? this.chartValues[0] : 0;
      const lastVal = this.chartValues[this.chartValues.length - 1] ? this.chartValues[this.chartValues.length - 1] : 0;

      const decreaseValue = firstVal - lastVal;
      this.percentDif = firstVal !== 0
        ? Math.round((decreaseValue / firstVal) * 100)
        : Math.round(decreaseValue * 100);
    },
  },
  watch: {
    async chartValues() {
      this.chartData();
    },
    async kpiData() {
      this.getData();
    },
  },
};
</script>
